import { Component, Input } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  AggFunc,
  BaseComponent,
  FormService,
  GridService,
  SalesOrderStockAllocationService,
  StockItemAllocation,
  StockItemAllocations,
  StockItemService,
  SummaryItem,
} from 'tms-lib';

@Component({
  selector: 'app-stock-enquiry-stock-allocations-modal',
  templateUrl: './stock-enquiry-stock-allocations-modal.component.html',
  styleUrl: './stock-enquiry-stock-allocations-modal.component.scss',
})
export class StockEnquiryStockAllocationsModalComponent extends BaseComponent {
  @Input() model: StockItemAllocations;
  @Input() showDelete = false;
  @Input() showBack = true;
  @Input() header = $localize`Stock Item Allocations`;

  constructor(
    private gridService: GridService,
    private salesOrderStockAllocationService: SalesOrderStockAllocationService,
    private stockItemService: StockItemService,
    private formService: FormService,
  ) {
    super();
  }

  summaryItems(model: StockItemAllocations): SummaryItem[] {
    return [
      { label: $localize`Stock Number`, value: model.stockNo },
      { label: $localize`Product`, value: model.productKey },
      { label: $localize`Description`, value: model.productDescription },
      { label: $localize`Product Type`, value: model.productType },
    ];
  }

  readonly columnDefs: ColDef[] = [
    this.gridService.text('allocationType', $localize`Allocation Type`),
    this.gridService.text('orderNo', $localize`Order Number`),
    this.gridService.text('customerKey', $localize`Customer Key`),
    this.gridService.text('customerName', $localize`Customer Name`),
    this.gridService.numberFormat('allocated', $localize`Allocated`, { aggFunc: AggFunc.sum }),
    this.gridService.date('deliveryDate', $localize`Delivery Date`),
  ];

  get rowData$(): Observable<StockItemAllocation[]> {
    return of(this.model?.allocations ?? []);
  }

  getModel() {
    this.stockItemService
      .stockItemAllocations(this.model.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model: StockItemAllocations) => (this.model = model));
  }

  delete(stockItemAllocations: StockItemAllocations) {
    this.salesOrderStockAllocationService
      .delete(stockItemAllocations.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.formService.markAsSaved();
        this.getModel();
      });
  }
}
